export const userActions = {
  LOAD_USER_LIST: 'LOAD_USER_LIST',
  LOAD_USER_LIST_SUCCESS: 'LOAD_USER_LIST_SUCCESS',
  LOAD_USER_LIST_FAIL: 'LOAD_USER_LIST_FAIL',

  LOAD_USER_BASIC_LIST: 'LOAD_USER_BASIC_LIST',
  LOAD_USER_BASIC_LIST_SUCCESS: 'LOAD_USER_BASIC_LIST_SUCCESS',
  LOAD_USER_BASIC_LIST_FAIL: 'LOAD_USER_BASIC_LIST_FAIL',

  LOAD_USER: 'LOAD_USER',
  LOAD_USER_SUCCESS: 'LOAD_USER_SUCCESS',
  LOAD_USER_FAIL: 'LOAD_USER_FAIL',

  UPDATE_USER: 'UPDATE_USER',
  UPDATE_USER_SUCCESS: 'UPDATE_USER_SUCCESS',
  UPDATE_USER_FAIL: 'UPDATE_USER_FAIL',

  loadUserList: () => ({
    type: userActions.LOAD_USER_LIST,
  }),
  loadUserListSuccess: data => ({
    type: userActions.LOAD_USER_LIST_SUCCESS,
    payload: { data },
  }),
  loadUserListFail: error => ({
    type: userActions.LOAD_USER_LIST_FAIL,
    payload: { error },
  }),

  loadUserBasicList: () => ({
    type: userActions.LOAD_USER_BASIC_LIST,
  }),
  loadUserBasicListSuccess: data => ({
    type: userActions.LOAD_USER_BASIC_LIST_SUCCESS,
    payload: { data },
  }),
  loadUserBasicListFail: error => ({
    type: userActions.LOAD_USER_BASIC_LIST_FAIL,
    payload: { error },
  }),

  loadUser: userId => ({
    type: userActions.LOAD_USER,
    payload: { userId },
  }),
  loadUserSuccess: data => ({
    type: userActions.LOAD_USER_SUCCESS,
    payload: { data },
  }),
  loadUserFail: error => ({
    type: userActions.LOAD_USER_FAIL,
    payload: { error },
  }),

  updateUser: (userId, user) => ({
    type: userActions.UPDATE_USER,
    payload: { userId, user },
  }),
  updateUserSuccess: () => ({
    type: userActions.UPDATE_USER_SUCCESS,
  }),
  updateUserFail: error => ({
    type: userActions.UPDATE_USER_FAIL,
    payload: { error },
  }),
};
